import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchTabs from "./searchTabs";

class SearchContainer extends Component {
  state = {
    defaultKey: "",
  };

  componentDidMount() {
    const items = this.props.location.pathname.split("/");
    let key = items[2];
    if (key === undefined) key = "aircraft";

    this.setState({ defaultKey: key });
  }

  render() {
    const { defaultKey } = this.state;

    if (defaultKey === "") return null;

    return (
      <React.Fragment>
        <div
          style={{
            padding: "20px",
            border: "1px solid darkgray",
            borderRadius: "5px",
          }}
        >
          <h5 style={{ marginBottom: "20px" }}>
            <FontAwesomeIcon icon="search" />
            &nbsp;Search
          </h5>
          <SearchTabs defaultKey={defaultKey} />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(SearchContainer);
